import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      d="M93.757 22.588a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M83.513 21.967a1.5 1.5 0 0 1 0 2.121l-9.994 9.994a1.5 1.5 0 0 1-2.122-2.121l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M71.397 21.967a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.5 1.5 0 1 1-2.122 2.121l-9.994-9.994a1.5 1.5 0 0 1 0-2.121"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      d="M42.441 97.732a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M16.567 16a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V17.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M8 24.567a1.5 1.5 0 0 1 1.5-1.5h14.134a1.5 1.5 0 0 1 0 3H9.5a1.5 1.5 0 0 1-1.5-1.5M18.514 95.232a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0M84.383 57.579c.004-.143.021-.283.021-.427 0-9.372-7.598-16.97-16.97-16.97-2.092 0-4.086.397-5.936 1.089C57.557 33.41 49.446 28 40.053 28c-13.254 0-23.999 10.745-23.999 23.999 0 1.816.219 3.577.601 5.278C9.522 58.169 4 64.242 4 71.617c0 7.989 6.476 14.465 14.465 14.465h62.486c7.989 0 14.465-6.476 14.465-14.465 0-6.804-4.704-12.495-11.033-14.038"
      clipRule="evenodd"
    />
    <path
      fill="#8F9BA8"
      fillRule="evenodd"
      d="M65.741 54.07c-.002-.088-.013-.173-.013-.261 0-5.726 4.642-10.367 10.367-10.367 1.278 0 2.496.242 3.627.665C82.13 39.304 87.085 36 92.823 36c8.097 0 14.661 6.564 14.661 14.661 0 1.109-.134 2.186-.367 3.224 4.357.545 7.731 4.255 7.731 8.761a8.837 8.837 0 0 1-8.837 8.837H67.837A8.837 8.837 0 0 1 59 62.646c0-4.157 2.875-7.634 6.741-8.576"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconCloudGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconCloudGreyscale);
export default Memo;
